export default __webpack_public_path__ + "static/media/checkmark.ace66252.svg";